import React from "react";
import styled from "styled-components";
import { StatusBadge } from "../../../../../globalComponents/ui/Badge";
import { resolveTriggerDisplay } from "./kpiRowUtils";

/* ── Styled-components ── */

const BadgeRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  flex-wrap: wrap;
`;

const TriggerChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: ${({ $isFallback }) => ($isFallback ? "#f5f9ff" : "#eff6ff")};
  border: ${({ $isFallback }) =>
    $isFallback ? "1px dashed #93c5fd" : "1px solid #bfdbfe"};
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #2563eb;
  font-family: var(--font-sans);
  white-space: nowrap;
  opacity: ${({ $isFallback }) => ($isFallback ? 0.85 : 1)};
`;

const SourceCount = styled.span`
  font-size: 9px;
  opacity: 0.7;
`;

/**
 * Inline trigger badge shown under the KPI name in the row header — a compact
 * counterpart to the expanded TriggerSection panel. Shares the aggregated range
 * and projection status style via resolveTriggerDisplay.
 *
 * @param {Array}   triggers   — resolved triggers for this KPI + date range
 * @param {boolean} isFallback — true when using a wider-range fallback
 * @param {object}  projection — computeProjection result (may be null)
 */
const TriggerBadge = ({ triggers, isFallback, projection }) => {
  const { min, max, unit, statusStyle } = resolveTriggerDisplay(triggers, projection);
  return (
    <BadgeRow>
      <TriggerChip $isFallback={isFallback}>
        ↯ Trigger: {min} – {max}{unit ? ` ${unit}` : ""}
        {triggers.length > 1 && <SourceCount>({triggers.length} src)</SourceCount>}
      </TriggerChip>
      {statusStyle && (
        <StatusBadge
          text={`${statusStyle.icon} ${statusStyle.label}`}
          color={statusStyle.color}
          bg={statusStyle.bg}
        />
      )}
    </BadgeRow>
  );
};

export default TriggerBadge;
